/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-charges.reducer';

export const DoctorChargesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorChargesEntity = useAppSelector(state => state.doctorCharges.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorChargesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorCharges.detail.title">DoctorCharges</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.id}</dd>
          <dt>
            <span id="consultationCharge">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.consultationCharge">Consultation Charge</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.consultationCharge}</dd>
          <dt>
            <span id="followupCharge">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.followupCharge">Followup Charge</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.followupCharge}</dd>
          <dt>
            <span id="followupDays">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.followupDays">Followup Days</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.followupDays}</dd>
          <dt>
            <span id="followupVisits">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.followupVisits">Followup Visits</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.followupVisits}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.cursor}</dd>
          <dt>
            <span id="chargeType">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.chargeType">Charge Type</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.chargeType}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.modifiedByID}</dd>
          <dt>
            <span id="emergencyHike">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.emergencyHike">Emergency Hike</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.emergencyHike}</dd>
          <dt>
            <span id="hishRiskHike">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.hishRiskHike">Hish Risk Hike</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.hishRiskHike}</dd>
          <dt>
            <span id="emergencyHikeType">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.emergencyHikeType">Emergency Hike Type</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.emergencyHikeType}</dd>
          <dt>
            <span id="hishRiskHikeType">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.hishRiskHikeType">Hish Risk Hike Type</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.hishRiskHikeType}</dd>
          <dt>
            <span id="multiplierApplied">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.multiplierApplied">Multiplier Applied</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.multiplierApplied ? 'true' : 'false'}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{doctorChargesEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorCharges.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorChargesEntity.doctor ? doctorChargesEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorCharges.hospital">Hospital</Translate>
          </dt>
          <dd>{doctorChargesEntity.hospital ? doctorChargesEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorCharges.scheme">Scheme</Translate>
          </dt>
          <dd>{doctorChargesEntity.scheme ? doctorChargesEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorCharges.specialty">Specialty</Translate>
          </dt>
          <dd>{doctorChargesEntity.specialty ? doctorChargesEntity.specialty.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-charges" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-charges/${doctorChargesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorChargesDetail;
